"use strict";import{tag as r}from"../custom-tag.js";export function checkCircledDefaultIcon({height:e=16,width:l=16,hidden:t=!1,title:a="Check circled default"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <mask
        id="check-circled-default_svg__mask0_6875_6473"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M19.457 5.326A10.007 10.007 0 1 0 7.645 21.012a9.94 9.94 0 0 0 4.36.988 10.008 10.008 0 0 0 7.452-16.674m1.476 7.171a8.954 8.954 0 1 1-17.88-1.009 8.954 8.954 0 0 1 17.88 1.01"
        />
        <path
          fill="currentColor"
          d="m9.886 15.46-3.16-3.16-.745.745 3.533 3.533a.527.527 0 0 0 .745 0l7.746-7.747-.745-.744z"
        />
      </mask>
      <g mask="url(#check-circled-default_svg__mask0_6875_6473)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=checkCircledDefault.js.map
